import type { GraphqlResponse } from '../../aicrowd-ui/graphql/fetch';

// Extract the first gql`…` template body and the GraphQL variables it declares.
// Variable definitions look like `$name:` in the operation signature; usages
// (`slug: $name`) have no colon after the `$name`, so this matches only defs.
export function parseQuery(code: string): { query: string | null; variables: string[] } {
  const match = code.match(/gql`([\s\S]*?)`/);
  const query = match ? match[1].trim() : null;
  const variables: string[] = [];
  if (query) {
    const seen = new Set<string>();
    const re = /\$([A-Za-z_]\w*)\s*:/g;
    let m: RegExpExecArray | null;
    while ((m = re.exec(query)) !== null) {
      if (!seen.has(m[1])) { seen.add(m[1]); variables.push(m[1]); }
    }
  }
  return { query, variables };
}

export function resolveVariables(
  variables: string[],
  values: Record<string, string>,
): { missing: string[]; vars: Record<string, string> } {
  const missing: string[] = [];
  const vars: Record<string, string> = {};
  for (const name of variables) {
    const v = (values[name] ?? '').trim();
    if (!v) missing.push(name);
    else vars[name] = v;
  }
  return { missing, vars };
}

export function interpretResult(
  res: GraphqlResponse,
  slugLabel: string,
): { data: unknown | undefined; status: string } {
  if (res.errors && res.errors.length) {
    return { data: undefined, status: `Showing FAKE_DATA — ${res.errors.map((e) => e.message).join('; ')}` };
  }
  if (!res.data || Object.keys(res.data as object).length === 0) {
    return { data: undefined, status: 'Showing FAKE_DATA — query returned no data' };
  }
  return { data: res.data, status: `Live data from "${slugLabel}"` };
}
